var timeout = null;
var timeout2 = null
var timeout3 = null;
document.addEventListener("DOMContentLoaded", () => {
  const ACTIVE_CLASS = 'active'
  const filterButtons = document.querySelectorAll(`.td-single-collection-selector`);
  const showAllButtons = document.querySelectorAll(`.td-show-all-button`)
  const stickyAnchor = document.querySelector('#td-sticky-anchor');
  
  const maybeTriggerEvent = (button) => {
    if (window.matchMedia("(max-width: 767px)")) {
      document.dispatchEvent(new CustomEvent('thumbnail-changed', {
        detail: {
          slide: button
        }
      }))
    }
  }

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => maybeTriggerEvent(button))
  })
  showAllButtons.forEach((button) => {
    button.addEventListener('click', () => maybeTriggerEvent(button))
  })



  document.addEventListener('thumbnail-changed', (e) => {
    const isMobile = window.matchMedia('(max-width: 920px)').matches;
    const maybeScrollToAnchor = () => {
      //Scroll back to top
      if (stickyAnchor){
        if (isMobile) {
           } else {
          stickyAnchor.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
    

    let showAll = false
    showAllButtons.forEach((showAllButton) => {
      if (e.detail.slide.id === showAllButton.id) {
        showAll = true
        document.querySelectorAll(`.product-gallery--${showAllButton.dataset.section}`).forEach((div) => {
          if (!div.classList.contains(ACTIVE_CLASS)) {
            div.classList.add(ACTIVE_CLASS)
          }
        })
        if (!showAllButton.classList.contains(ACTIVE_CLASS)) {
          showAllButton.classList.add(ACTIVE_CLASS)
        }
      }
    })
    if (showAll) {
      maybeScrollToAnchor()
      filterButtons.forEach((button) => {
        if (button.classList.contains(ACTIVE_CLASS)) {
          button.classList.remove(ACTIVE_CLASS)
        }
      })
      return
    }
    let hasMatched = false
    filterButtons.forEach((filterButton) => {
      const matchingDiv = document.querySelector(`#${filterButton.dataset.div}`)
      if (e.detail.slide.id === filterButton.id) {
        filterButton.classList.add(ACTIVE_CLASS)

        // filterButton.scrollIntoView({ behavior: 'smooth' });
        
        if (matchingDiv) {
          hasMatched = true
          if (!matchingDiv.classList.contains(ACTIVE_CLASS)) {
            matchingDiv.classList.add(ACTIVE_CLASS)
          }
        }
      } else {
       filterButton.classList.remove('active') 
         if (matchingDiv) {
          if (matchingDiv.classList.contains('active')) {
            matchingDiv.classList.remove('active')
          }
        }
      }
    })
    if (hasMatched) {
      if(isMobile) {
        
      } else {
        maybeScrollToAnchor()
      }
      showAllButtons.forEach((button) => {
        if (button.classList.contains(ACTIVE_CLASS)) {
          button.classList.remove(ACTIVE_CLASS)
        }
      })
    }

    // scroll into view
      if(window['isIntersecting']) {
        return;
      }
      
      const absoluteElementTop = document.querySelector('div.active h2').offsetTop;
      
      const middle = absoluteElementTop + 40;
      
      // set this flag, so that auto position detect would not trigger any action of its own
      window['isSmoothScrolling'] = true;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        window['isSmoothScrolling'] = false;
      }, 1200)
    
      // window.scrollTo({
      //   top: middle,
      //   behavior: 'smooth'
      // })
      setTimeout(() => {
          const absoluteElementTop = document.querySelector('div.active h2').offsetTop;
            
            const middle = absoluteElementTop; // + 40;
            window.scrollTo({
              top: middle,
              behavior: 'smooth'
            })
          
      },100)
   
  })

  let stickyTabs = document.querySelector('.td-sticky-tabs');
  const isMobile = window.matchMedia('(max-width: 920px)').matches;
  
  if (stickyTabs){
    if(isMobile) {
      const divs = document.querySelectorAll('div.page-width');
      divs.forEach(function(div) {
          div.removeAttribute('id');
      });
    } else {
      window.addEventListener('scroll', function() {
          if (stickyTabs.offsetTop > 0) {
            stickyTabs.classList.add('td-stuck-tabs');
          } else {
            stickyTabs.classList.remove('td-stuck-tabs');
          }
      });
    }
  }

    // auto detect position and highlight the top nav buttons
    (() => {
        window['isSmoothScrolling'] = true;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          window['isSmoothScrolling'] = false;
        }, 1200)
      
        const galleries = document.querySelectorAll('.product-gallery > .swiffy-slider');
        const headers =  document.querySelectorAll('.product-gallery > .section-header');
    
        const galleriesUpcallback = (entries, observer) => {
            if(!isMobile) {
              return
            }
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const direction = entry.boundingClientRect.top < 0 ? 'up' : 'down';
                    if(direction === 'up') {
                      onIntersect(entry.target);
                    }
                }
            });
        };

      const headersDownCallback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const direction = entry.boundingClientRect.top < 0 ? 'up' : 'down';
                    
                    if(direction === 'down') {
                      onIntersect(entry.target);
                    }
                }
            });
        };

        const headersUpCallback = (entries, observer) => {
            // if(isMobile) {
            //   return
            // }
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const direction = entry.boundingClientRect.top < 0 ? 'up' : 'down';
                    
                    
                    if(direction === 'up') {
                      onIntersect(entry.target);
                    }
                }
            });
        };
    
        const galleriesObserver = new IntersectionObserver(galleriesUpcallback, {rootMargin: '-100% 0px 0px 0px'});
        const headersDownObserver = new IntersectionObserver(headersDownCallback, {rootMargin: '0px 0px -200px 0px'});
        const headersUpObserver = new IntersectionObserver(headersUpCallback, {rootMargin: '0px 0px 0px 0px'});
    
        galleries.forEach(gallery => {
            galleriesObserver.observe(gallery);
        });

        headers.forEach(header => {
          headersDownObserver.observe(header);
          headersUpObserver.observe(header);
        })
    
        const onIntersect = (element) => {
            
          
              // in case the scroll is triggered by clicking on the collection nav
              if(window['isSmoothScrolling']) {
                  return;
              }
              
            
              document.querySelector('.product-gallery.active')?.classList.remove('active');
              const selectedGallery = element.closest('.product-gallery');
              
              selectedGallery.classList.add('active');
      
              
               const collectionContainer = document.querySelector('.collection-selector-flex--no-title');
              const activeNavItem = document.querySelector(`.collection_nav .collection-selector[data-div="${selectedGallery.id}"]`)
              if( activeNavItem) {
  
                Array.from(document.querySelectorAll('.collection_nav .collection-selector.active')).forEach(item => {
                  if(item !== activeNavItem) {
                    item.classList.remove('active')
                  }
                });
                
                activeNavItem.classList.add('active');
                window['isIntersecting'] = true;
                
                // activeNavItem.click();
          
                const scrollX = activeNavItem.offsetLeft - collectionContainer.scrollLeft - (collectionContainer.offsetWidth / 2) + (activeNavItem.offsetWidth / 2);
                    
                // Smooth scroll to the calculated position
                collectionContainer.scrollBy({ left: scrollX, behavior: 'smooth' });
                
                clearTimeout(timeout2);
                timeout2 = setTimeout(() => {
                    window['isIntersecting'] = false;
                }, 500)
  
               
              }
            
        };
    })();
   
  // workaround to prevent extra padding on left of pills navigation on auto scroll
(() => {
  const container = document.querySelector('div.td-sticky-tabs > div.collection_nav > div');

  const calculateMaxScroll = () => {
    const children = container.children;
    let totalWidth = 0;
    for (let child of children) {
      totalWidth += child.offsetWidth;
    }
    return totalWidth - container.offsetWidth + 60;
  };

  container.addEventListener('scroll', () => {
    if (container.scrollLeft < 0) {
      container.scrollLeft = 0;
    } else {
      const maxScroll = calculateMaxScroll();
      if (container.scrollLeft > maxScroll) {
        container.scrollLeft = maxScroll;
      }
    }
  });
})();

});